// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"82fe66fd","563":"036e352d","944":"036e352d","996":"01dc706a"}[chunkId] + ".chunk.css";
};